import { DeviceStatus } from '~/services/api/enums';
import { IDevice } from '~/services/api/devices/types';
import { DeviceAction, IActions } from './types';

const deviceStatusActionsMap = {
  [DeviceStatus.Available]: [
    DeviceAction.Assign,
    DeviceAction.MarkAsLost,
    DeviceAction.ActivateSim,
    DeviceAction.Delete,
  ],
  [DeviceStatus.Ready]: [DeviceAction.Unassign, DeviceAction.MarkAsLost, DeviceAction.ActivateSim],
  [DeviceStatus.Issued]: [DeviceAction.Unregister, DeviceAction.ActivateSim],
  [DeviceStatus.Returning]: [
    DeviceAction.MarkAsReturned,
    DeviceAction.MarkAsLost,
    DeviceAction.ActivateSim,
  ],
  [DeviceStatus.Returned]: [
    DeviceAction.MarkAsDefective,
    DeviceAction.MarkAsAvailable,
    DeviceAction.ActivateSim,
    DeviceAction.Delete,
  ],
  [DeviceStatus.Lost]: [
    DeviceAction.MarkAsReturned,
    DeviceAction.ActivateSim,
    DeviceAction.DeactivateSim,
    DeviceAction.Delete,
  ],
  [DeviceStatus.Defective]: [
    DeviceAction.ActivateSim,
    DeviceAction.DeactivateSim,
    DeviceAction.Delete,
  ],
};

export const getDevicesActions = (devices: IDevice[], checkedDevicesIds: number[]): IActions =>
  devices
    .filter(x => checkedDevicesIds.includes(x.id))
    .flatMap(x =>
      deviceStatusActionsMap[x.status]
        .filter(y => y !== DeviceAction.ActivateSim || !x.isSimActive)
        .filter(y => y !== DeviceAction.DeactivateSim || x.isSimActive)
        .map(action => ({ action, id: x.id })),
    )
    .reduce((prev, device) => ({ ...prev, [device.action]: [...prev[device.action], device.id] }), {
      [DeviceAction.Assign]: [],
      [DeviceAction.Unassign]: [],
      [DeviceAction.Unregister]: [],
      [DeviceAction.MarkAsReturned]: [],
      [DeviceAction.MarkAsLost]: [],
      [DeviceAction.MarkAsDefective]: [],
      [DeviceAction.MarkAsAvailable]: [],
      [DeviceAction.DeactivateSim]: [],
      [DeviceAction.ActivateSim]: [],
      [DeviceAction.Delete]: [],
    });

export default {};
